import BreakoutModuleWide from './BreakoutModuleWide'

export default BreakoutModuleWide
